import { render } from "./index.vue?vue&type=template&id=ef44d588"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/services-detail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef44d588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef44d588', __exports__)) {
    api.reload('ef44d588', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ef44d588", () => {
    api.rerender('ef44d588', render)
  })

}


export default __exports__